import { Navigate } from 'react-router-dom';
import { IRouteConfig, ROUTES } from '@/models/router.model';
import ContentPageEditor from '@/pages/content-page-editor';
import ContentPagesList from '@/pages/content-pages-list';
import FinancialSettings from '@/pages/financial-settings';
import {
  PartnerDetails,
  Profile,
  UsersList,
  PartnersList,
  Categories,
  CategoryDetails,
  RegionsAndPickup,
  BannersList,
  RegionSettlements,
  Import,
  ImportsList,
  StocksImport,
  Products,
  StockBalances,
  ProductDetails,
  Orders,
  OrdersDetails,
  SubscriptionsList,
  Seo,
  Settings,
  Feedbacks,
  ProductCreate,
  Feeds,
  Commission,
  GenerateQr,
  CancelledOrders,
} from '@/pages';
import { FilterValuesListContainer } from '@/modules/Categories';
import { RegionsAndPickupTabs } from '@/modules/Regions';
import { UsersListTabs } from '@/modules/UsersList/helpers/configs';
import Dashboard from 'src/pages/dashboard';

export const routesConfig: IRouteConfig[] = [
  {
    title: 'Dashboard',
    path: ROUTES.DASHBOARD,
    component: <Dashboard />,
  },
  {
    title: 'Cancelled orders',
    path: ROUTES.CANCELLED_ORDERS,
    component: <CancelledOrders />,
  },
  {
    title: 'About Us',
    path: ROUTES.ABOUT_US,
    component: <p>ABOUT US</p>,
  },
  {
    title: 'Profile',
    path: ROUTES.PROFILE,
    component: <Profile />,
  },
  {
    title: 'Orders',
    path: ROUTES.ORDERS,
    component: <Orders />,
  },
  {
    title: 'Order details',
    path: ROUTES.ORDER_DETAILS,
    component: <OrdersDetails />,
  },
  {
    title: 'Users List',
    path: ROUTES.USERS_LIST,
    component: <UsersList />,
  },
  {
    title: 'Partner Details',
    path: ROUTES.PARTNER_DETAILS,
    component: <PartnerDetails />,
  },
  {
    title: 'Partners List',
    path: ROUTES.PARTNERS_LIST,
    component: <PartnersList />,
  },
  {
    title: 'Users List',
    path: ROUTES.USERS_LIST_INDEX,
    component: <Navigate to={`${ROUTES.USERS_LIST_INDEX}/${UsersListTabs.ADMIN}`} replace />,
  },
  {
    title: 'Categories and filters',
    path: ROUTES.CATEGORIES,
    component: <Categories />,
  },
  {
    title: 'Category details',
    path: ROUTES.CATEGORY_DETAILS,
    component: <CategoryDetails />,
  },
  {
    title: 'Regions and Pickup points',
    path: ROUTES.REGIONS_AND_PICKUP,
    component: <RegionsAndPickup />,
  },
  {
    title: 'Regions and Pickup points',
    path: ROUTES.REGIONS_AND_PICKUP_INDEX,
    component: <Navigate to={`${ROUTES.REGIONS_AND_PICKUP_INDEX}/${RegionsAndPickupTabs.REGIONS}`} replace />,
  },
  {
    title: 'Regions Settlements',
    path: ROUTES.REGION_SETTLEMENTS,
    component: <RegionSettlements />,
  },
  {
    title: 'Banners list',
    path: ROUTES.BANNERS,
    component: <BannersList />,
  },
  {
    title: 'Content pages',
    path: ROUTES.CONTENT_PAGES,
    component: <ContentPagesList />,
  },
  {
    title: 'Content page editor',
    path: ROUTES.CONTENT_PAGE_DETAILS,
    component: <ContentPageEditor />,
  },
  {
    title: 'Import',
    path: ROUTES.IMPORT,
    component: <Import />,
  },
  {
    title: 'Products',
    path: ROUTES.PRODUCTS,
    component: <Products />,
  },
  {
    title: 'Stock balances',
    path: ROUTES.STOCK_BALANCES,
    component: <StockBalances />,
  },
  {
    title: 'Product Create',
    path: ROUTES.PRODUCT_CREATE,
    component: <ProductCreate />,
  },
  {
    title: 'Product Details',
    path: ROUTES.PRODUCT_DETAILS,
    component: <ProductDetails />,
  },
  {
    title: 'Imports List',
    path: ROUTES.IMPORTS_LIST,
    component: <ImportsList />,
  },
  {
    title: 'Generate QR',
    path: ROUTES.GENERATE_QR,
    component: <GenerateQr />,
  },
  {
    title: 'Stocks Imports',
    path: ROUTES.IMPORT_STOCKS,
    component: <StocksImport />,
  },
  {
    title: 'Category filter values',
    path: ROUTES.CATEGORY_FILTER_DETAILS,
    component: <FilterValuesListContainer />,
  },
  {
    title: 'Subscriptions',
    path: ROUTES.SUBSCRIPTIONS,
    component: <SubscriptionsList />,
  },
  {
    title: 'SEO',
    path: ROUTES.SEO,
    component: <Seo />,
  },
  {
    title: 'FEEDS',
    path: ROUTES.FEEDS,
    component: <Feeds />,
  },
  {
    title: 'Commission',
    path: ROUTES.COMMISSION,
    component: <Commission />,
  },
  {
    title: 'Settings',
    path: ROUTES.SETTINGS,
    component: <Settings />,
  },
  {
    title: 'Cash registers',
    path: ROUTES.ACCOUNTING_CASH_REGISTERS,
    component: <FinancialSettings />,
  },
  {
    title: 'Feedbacks',
    path: ROUTES.FEEDBACKS,
    component: <Feedbacks />,
  },
];
